import { IconWrapper } from '../runtime';
export default IconWrapper('bell', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2.87625 6.19827C2.87625 3.46541 5 0.999786 8 0.999786C11 0.999786 12.9113 3.46541 12.9113 6.19827C12.9113 8.02846 12.9112 9.65884 12.9112 10.0774C12.9112 10.8235 13.6421 11.7138 13.9742 12.0799C14.0323 12.144 13.9859 12.2498 13.8986 12.2498H2.10089C2.0188 12.2498 1.97122 12.1548 2.01913 12.0891C2.28153 11.729 2.87621 10.8299 2.87621 10.0774C2.87621 9.65884 2.87625 8.02846 2.87625 6.19827Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6 13.9998C6 14.9939 6.89543 15.7998 8 15.7998C9.10457 15.7998 10 14.9939 10 13.9998H6Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});